async function updateLiveContent(updatedSections) {
  try {
    for (const section of sectionsToRender) {
      const content = updatedSections[section.section_id];
      const html = new DOMParser().parseFromString(content, 'text/html');
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (sourceElement?.classList.contains('is-empty')) {
          sourceElement.classList.remove('is-empty');
        }
        if (targetElement && sourceElement) {

          targetElement.replaceWith(sourceElement);
        }
        if (selector.includes('icon-bubble')) {
          const newHTML = document.createElement('div');
          newHTML.innerHTML = content;
          targetElement.innerHTML = newHTML.children[0].innerHTML;
        }
      });
    }
  } catch (e) {
    console.error(e);
  }
}

const sectionsToRender = [
  {
    section_id: 'brand-cart-drawer',
    selectors: ['.drawer__inner .drawer__header', 'brand-cart-drawer-items', 'brand-cart-drawer .drawer__footer'],
  },
  {
    section_id: 'kenvue-cart-icon-bubble',
    selectors: ['#kenvue-cart-icon-bubble'],
  },
];

async function cartAddItem(variantId, productId) {
  try {
    const body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: sectionsToRender.map((section) => section.section_id),
    });
    const response = await fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } });
    const data = await response.json();
    if (data.items.length > 0) {
      const cartDrawer = document.querySelector('brand-cart-drawer');
      if (cartDrawer) cartDrawer.classList.remove('is-empty');
    }
    await updateLiveContent(data.sections);
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell', cartData: {...data, product_id: productId}, variantId: variantId });
  } catch (e) {
    console.error(e);
  }
}

async function addUpsellProductToCart(event) {
  // debugger;
  event.preventDefault();
  const parentCard = event.target.closest('.product-upsell-cart__container');
  parentCard.classList.add('--loading');
  try {
    const { variantId, productId } = event.currentTarget.dataset
    if (!variantId) {
      throw new Error('Variant ID not found');
    }
    await cartAddItem(variantId, productId);
  } catch (e) {
    console.error(e);
  }
}
